import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpTokenInterceptor } from './interceptors/token.interceptor';
import { ProfileResolver } from './resolvers/profile.resolver';

import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { CustomErrorComponent } from './views/error/custom-error.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ToastrModule } from 'ngx-toastr';

// Import components
import { ComponentsModule } from '@app/components/components.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { environment } from '@env/environment';

@NgModule({ declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        P404Component,
        P500Component,
        CustomErrorComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AppAsideModule,
        AppBreadcrumbModule.forRoot(),
        AppFooterModule,
        AppHeaderModule,
        AppSidebarModule,
        BsDropdownModule,
        TabsModule,
        IconModule,
        IconSetModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(),
        ComponentsModule,
        RecaptchaV3Module,
        NgSelectModule], providers: [
    provideCharts(withDefaultRegisterables()),
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpTokenInterceptor,
            multi: true
        },
        IconSetService,
        ProfileResolver,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
